const WithdrawingButton = ({ onTap, value }) => {
  return <div className="withdrawing-button" onClick={onTap} >
    <h3>{value}</h3>
    <img src="/assets/icons/ic_roblux_small.svg" alt="ic_roblux_small" />
  </div>;
};

export default WithdrawingButton;